/*
 * Copyright (C) 2024 SimpliCity Digital Inc - All Rights Reserved
 */

import { useState, useEffect } from "react";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { useAuth } from "cms/auth/hooks/use-auth";
import { Logger } from "cms/utils/log/logger";

const useImageLoader = () => {
    
    const { token } = useAuth();
    
    const [image, setImage] = useState(null);
    const [settings, setSettings] = useState(null);
    const [loaded, setLoaded] = useState(false);
    const [aspectRatio, setAspectRatio] = useState(1);
    // const [imageDimensions, setImageDimensions] = useState({})
    // const { width, height } = imageDimensions || {}
    const [width, setWidth] = useState(0);
    const [height, setHeight] = useState(0);
    
    const title = image?.title;
    const alt = image?.alt;
    const url = image?.url;
    
    const preloadImage = async (image) => {
        const url = image?.url;
        // const alt = image?.alt;
        // let data = {...image};
        const retrieve = async (url) => {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.src = url;
                img.onload = () => {
                    resolve(img);
                };
                img.onerror = reject;
            });
        };
        try {
            return await retrieve(url);
        } catch (err) {
            Logger.error(err);
            return;
        }
    };
    
    const preloadImageArray = async (urls) => {
        try {
            const images = [];
            for (const url of urls) {
                const image = await preloadImage(url);
                images.push(image);
            }
            return images;
        } catch (err) {
            Logger.error(err);
        }
    };
    
    const fetchImageData = async (image_guid) => {
        if (!image_guid) {
            return;
        }
        return SimpliCityAdminSDK.images.findOne(token, image_guid);
    };
    const setDefaultDimensions = () => {
        setWidth(0);
        setHeight(0);
    };
    
    const measureImage = (imageUrl) => {
        const pseudoImage = new Image();
        pseudoImage.src = imageUrl;
        
        pseudoImage.onload = () => {
            setWidth(pseudoImage.width);
            setHeight(pseudoImage.height);
            const ratio = Math.floor(pseudoImage.width / pseudoImage.height);
            setAspectRatio(ratio);
            setLoaded(true);
        };
        pseudoImage.onerror = (err) => {
            Logger.debug("[useImageLoader] image error", { error: err });
            Logger.error(err);
            setLoaded(false);
        };
    };
    
    const fetchImage = async (image_guid, settings) => {
        if (image_guid) {
            setLoaded(false);
            setSettings(settings);
            const current_image = await SimpliCityAdminSDK.images.findOne(token, image_guid);
            if (current_image && current_image.guid) {
                setImage(current_image);
                if (image) {
                    measureImage(image?.url);
                    // Logger.debug(imageDimensions);
                }
                // Logger.debug('setImage', current_image);
            } else {
                Logger.error("[useImageLoader] Could not load image...", { guid: current_image.guid });
            }
        } else {
            setImage(undefined);
            setDefaultDimensions();
            // setLoaded(true);
        }
    };
    
    useEffect(() => {
        if (image?.url) {
            measureImage(image?.url);
        }
    }, [image]);
    
    return {
        image,
        width,
        height,
        title,
        alt,
        url,
        loaded,
        aspectRatio,
        settings,
        fetchImage,
        fetchImageData,
        preloadImage,
        preloadImageArray,
    };
};

export { useImageLoader };
